<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <b-col sm="12">
        <div class="card">
          <div class="card-body">
            <b-row class="justify-content-between">
              <b-col sm="12" md="8" xl="3" class="pt-1">
                <rating-filter @ratingOption="handleRatingOption"></rating-filter>
              </b-col>
              <b-col sm="12" md="4" xl="9" class="text-end pt-1">
                <b-dropdown variant="primary">
                  <template v-slot:button-content>
                    <i class="mdi mdi-search-web me-1"></i>
                    {{ $t('pages.review.index.track_products') }}
                  </template>
                  <b-dropdown-item :disabled="!$auth.priv('has-marketplace')" @click="showAddAsinModal" href="javascript: void(0);">
                    {{ $t('pages.review.index.your_listing') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showCustomAsinModal">
                    {{ $t('pages.review.index.custom_asin') }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6 col-12">
                    <PerPageSelector v-model="query.perPage"
                                     :available-per-page-options="availablePerPageOptions"
                    ></PerPageSelector>
                  </div>
                  <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
                    <DataTableSearch v-model="query.filter"
                                     :place-holder="$t('pages.review.index.search')">
                    </DataTableSearch>
                  </div>
                </div>
              </div>
              <div>
                <b-table
                    ref="productTable"
                    striped
                    hover
                    :empty-text="$t('components.bootstrap_table.empty_text')"
                    :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
                    show-empty
                    :fields="fields"
                    :items="getProducts"
                    :stacked="$store.state.app.isMobile"
                    :filter="query.filter"
                    :per-page="query.perPage"
                    :sort-by="query.sortBy"
                    :sort-desc="query.sortDesc"
                    :current-page="query.page"
                >
                  <template #empty>
                    <no-result
                        :title="$t('pages.review.index.track_first_product')"
                        :subtitle="$t('pages.review.index.help_review_message')"
                        icon="archive">
                      <template #btn>
                        <b-dropdown variant="light">
                          <template v-slot:button-content>
                            <i class="mdi mdi-search-web me-1"></i>
                            {{ $t('pages.review.index.track_products') }}
                          </template>
                          <b-dropdown-item :disabled="!$auth.priv('has-marketplace')" @click="showAddAsinModal" href="javascript: void(0);">
                            {{ $t('pages.review.index.your_listing') }}
                          </b-dropdown-item>
                          <b-dropdown-item @click="showCustomAsinModal">
                            {{ $t('pages.review.index.custom_asin') }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </no-result>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div class="list-group list-group-flush" v-if="data.item.ready">
                      <div class="media align-items-center">
                        <div class="me-3">
                          <b-avatar
                              :src="data.item.img"
                              alt=""
                              square
                              size="60"
                          />
                        </div>
                        <div class="media-body overflow-hidden">
                          <h5 class="font-size-13 text-truncate item-name">
                            {{ data.item.name }}
                          </h5>
                          <a class="mb-0 text-truncate"
                             @click="openAmazonPage(data.item.url)"
                             href="javascript: void(0);">
                            <i class="mdi mdi-open-in-new"></i>
                            {{ data.item.asin }}
                          </a>
                          <span>{{ data.item.seller_sku }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="media align-items-center">
                        <div class="me-3">
                          <b-spinner variant="primary"></b-spinner>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h5 class="font-size-13 text-truncate">
                            {{ data.item.asin }}
                          </h5>
                          <f-badge variant="primary" class="mb-0 text-truncate">
                            {{ $t('pages.review.index.processing') }}
                          </f-badge>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(rating)="data">
                    <checked-data :flag="data.item.ready">
                      <div v-if="data.item.history">
                        <star :star="parseFloat(data.item.history.rating)"></star>
                      </div>
                    </checked-data>
                  </template>

                  <template v-slot:cell(total_reviews)="data">
                    <checked-data :flag="data.item.ready">
                      <div v-if="data.item.history">
                        <f-badge variant="primary">{{ data.item.history.total_reviews }}</f-badge>
                      </div>
                    </checked-data>
                  </template>

                  <!--                  <template v-slot:cell(current_price)="data">-->
                  <!--                    <checked-data :flag="data.item.ready">-->
                  <!--                      <div v-if="data.item.history">-->
                  <!--                        {{ data.item.history.currency }}-->
                  <!--                        <strong>{{ data.item.history.current_price }}</strong>-->
                  <!--                      </div>-->
                  <!--                    </checked-data>-->
                  <!--                  </template>-->

                  <!--                  <template v-slot:cell(discount)="data">-->
                  <!--                    <checked-data :flag="data.item.ready">-->
                  <!--                      <div v-if="data.item.history">-->
                  <!--                        % {{ Math.round(data.item.history.discount) }}-->
                  <!--                      </div>-->
                  <!--                    </checked-data>-->
                  <!--                  </template>-->

                  <template v-slot:cell(last_review)="data">
                    <checked-data :flag="!!data.item.last_review">
                      <div>
                        {{ data.item.last_review | date }}
                      </div>
                    </checked-data>
                  </template>

                  <template v-slot:cell(status)="data">
                    <checked-data :flag="data.item.ready">
                      <div v-if="data.item.ready">
                        <i class="mdi font-size-18"
                           :class="data.item.status ? 'mdi-check-circle-outline text-success' : 'mdi-alert-circle-outline text-danger'">
                        </i>
                      </div>
                    </checked-data>
                  </template>

                  <template v-slot:cell(highlights)="data">
                    <checked-data :flag="data.item.ready">
                      <div v-if="data.item.ready">
                        <b-btn variant="success" @click="openReviewHighlights(data.item.id)" size="sm">
                          <i class="mdi mdi-eye"></i>
                          {{ $t('pages.review.index.highlights_btn') }}
                        </b-btn>
                      </div>
                    </checked-data>
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-dropdown
                        class="card-drop"
                        variant="white"
                        right
                        toggle-class="p-0"
                        menu-class="dropdown-menu-end"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>

                      <b-dropdown-item
                          @click="$router.push({ name: 'reviews.show', params: {productId : data.item.id}})">
                        <i class="mdi mdi-eye-outline text-success"></i>
                        {{ $t('pages.review.index.show_reviews') }}
                      </b-dropdown-item>

                      <b-dropdown-item @click="deleteProduct(data.item)">
                        <i class="fas fa-trash-alt text-danger me-1"></i>
                        {{ $t('pages.templates.delete') }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>

                </b-table>
                <div class="row">
                  <div class="col-sm">
                    <Pagination v-model="query.page" :meta="products.meta"></Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <div class="col-lg-8">
        <product-reviews :data="chartData"></product-reviews>
      </div>
      <div class="col-lg-4">
        <latest-reviews></latest-reviews>
      </div>
    </div>
    <add-asin-modal @track="refreshTable"></add-asin-modal>
    <catalog-products-modal></catalog-products-modal>
    <custom-asin-track @track="refreshTable"></custom-asin-track>
    <review-highlights :selectedProduct="selectedProduct"></review-highlights>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import queryBuilder from "../../mixins/queryBuilder";
import DataTableSearch from "../../components/DataTableSearch";
import PerPageSelector from "../../components/PerPageSelector";
import ProductReviews from "./components/ProductReviews";
import LatestReviews from "./components/LatestReviews";
import AddAsinModal from "./components/AddAsinModal";
import Star from "./components/Star";
import ProductService from "../../Services/Api/ProductService";
import RatingFilter from "./components/RatingFilter";
import ReviewStatMixin from "../../mixins/ReviewStatMixin";
import CatalogProductsModal from "../Campaigns/Pages/Components/ExcludeFilter";
import CustomAsinTrack from "./components/CustomAsinTrack";
import Swal from "sweetalert2";
import NoResult from "../../components/widgets/NoResult";
import ReviewHighlights from "./components/Analysis/ReviewHighlights";

export default {
  name: "ReviewList",
  mixins: [queryBuilder, ReviewStatMixin],
  page() {
    return {
      title: this.$t('pages.review.index.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {
    ReviewHighlights,
    NoResult,
    CustomAsinTrack,
    CatalogProductsModal,
    RatingFilter,
    AddAsinModal,
    LatestReviews,
    ProductReviews,
    PerPageSelector,
    DataTableSearch,
    Pagination,
    Star
  },
  data() {
    return {
      title: this.$t('pages.review.index.title'),
      items: [
        {
          text: this.$t('pages.review.index.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.review.index.items.second'),
          active: true,
        },
      ],
      fields: [
        {key: 'name', sortable: false, label: this.$t('pages.review.index.fields.name')},
        {key: 'rating', sortable: false, label: this.$t('pages.review.index.fields.rating'), tdClass: 'star-cell'},
        {key: 'total_reviews', sortable: false, label: this.$t('pages.review.index.fields.total_reviews')},
        // {key: 'current_price', sortable: false, label: this.$t('pages.review.index.fields.current_price')},
        // {key: 'discount', sortable: false, label: this.$t('pages.review.index.fields.discount')},
        {key: 'last_review', sortable: false, label: this.$t('pages.review.index.fields.last_review')},
        {key: 'highlights', sortable: false, label: this.$t('pages.review.index.fields.last_review')},
        {key: 'action', sortable: false, label: this.$t('pages.review.index.fields.action')},
      ],
      dateRange: null,
      templateType: null,
      products: [],
      monthlyCounts: null,
      chartData: null,
      selectedProduct: null
    }
  },
  methods: {
    async getProducts(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: products} = await ProductService.all({query})
      this.products = products
      return products.data
    },
    showAddAsinModal() {
      this.$bvModal.show('add-asin-modal')
    },
    openReviewHighlights(productId) {
      this.selectedProduct = productId
      this.$bvModal.show('review-highlights-modal')
    },
    openAmazonPage(url) {
      window.open(url, '_blank')
    },
    async refreshTable() {
      await this.$refs.productTable.refresh()
      await this.$store.dispatch('quota/getSubscriptionQuota')
    },
    handleRatingOption(e) {
      this.query.ratingOption = e
      this.refreshTable()
    },
    async countMonthly() {
      const {data: statistics} = await ProductService.countsMonthly()
      this.chartData = statistics.data
    },
    startBroadcast() {
      window.Echo.private(`user-${this.$auth.user().id}`).listen('.product.refresh', () => {
        this.refreshTable()
      })
    },
    stopBroadcast() {
      window.Echo.private(`user-${this.$auth.user().id}`).stopListening('.product.refresh')
    },
    showCustomAsinModal() {
      this.$bvModal.show('custom-asin-modal')
    },
    deleteProduct(item) {
      Swal.fire({
        title: this.$t('pages.review.index.delete_title', {asin: item.asin}),
        icon: "error",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        confirmButtonText: this.$t('pages.review.index.delete_confirm')
      }).then(result => {
        if (result.value) {
          const product = {
            asin: item.asin,
            marketplace_id: item.marketplace_id
          }
          ProductService.untrackProduct({payload: product}).then(() => {
            this.$store.dispatch('quota/getSubscriptionQuota')
            this.refreshTable()
          })
        }
      });
    }
  },
  destroyed() {
    this.stopBroadcast()
  },
  created() {
    this.countMonthly()
    this.startBroadcast()
  }
}
</script>

<style scoped>
.item-name {
  overflow: hidden;
  width: 220px;
}
</style>